import { useContext } from "react"

import * as Scrivito from "scrivito"
import {
  NotificationContext,
  isNotificationType
} from "shared/context/NotificationContext"
import { useAuth } from "shared/lib/useAuth"
import { useEvent } from "shared/lib/useEvent"
import { AppActionType } from "shared/types/AppAction"
import { Button } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { LinkList } from "shared/ui/link-list/LinkList"
import { Tooltip } from "shared/ui/tooltip/Tooltip"

import { useAppAction } from "app/useAppAction"

import { LinkListActionWidget } from "./LinkListActionWidgetClass"

Scrivito.provideComponent(LinkListActionWidget, ({ widget }) => {
  const performAction = useAppAction()
  const notificationContext = useContext(NotificationContext)
  const { isAuthenticated } = useAuth()

  const handleClick = useEvent(() => {
    if (widget.get("action")) {
      performAction(widget.get("action") as AppActionType)
    }
  })

  const notificationType = widget.get("notificationType") || ""
  const hideForUnauthenticatedUsers = widget.get("hideForUnauthenticatedUsers")
  const hideTooltip = widget.get("hideTooltip")

  // Hide the action if user is not authenticated and hideForUnauthenticatedUsers is true
  if (hideForUnauthenticatedUsers && !isAuthenticated) {
    return null
  }

  const notificationCount = isNotificationType(notificationType)
    ? notificationContext?.[notificationType] ?? 0
    : 0

  const tooltipText =
    notificationCount > 0
      ? `${widget.get("title")} (${notificationCount})`
      : widget.get("title")

  return (
    <Tooltip content={tooltipText} placement="right" disabled={hideTooltip}>
      <LinkList.GenericWrapper>
        <Button
          className="link"
          variant="link"
          icon={widget.get("icon") as IconName}
          onClick={handleClick}
          notificationCount={notificationCount}
          label={widget.get("title")}
          aria-label={tooltipText}
        />
      </LinkList.GenericWrapper>
    </Tooltip>
  )
})
